import Language from '../Language'

export default new Language(
  'Serbian',
  ['Januar', 'Februar', 'Mart', 'April', 'Maj', 'Jun', 'Jul', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar'],
  ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'],
  ['Ned', 'Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub']
)
// eslint-disable-next-line
;



// WEBPACK FOOTER //
// ./src/locale/translations/sr.js